export default __webpack_public_path__ + "static/media/275802__davidjgurney__ticking-stopwatch-dry.b2bebeca.wav";